module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "tjhzs-footer"
  }, [_c('div', {
    staticClass: "footer-box"
  }, [_vm._l((_vm.items), function(item) {
    return _c('block', {
      attrs: {
        "info": item
      }
    })
  }), _vm._v(" "), _c('web-info', {
    attrs: {
      "webinfo": _vm.webInfo
    }
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "version"
  }, [_vm._v("Copyright © TJHZS.COM 隶属于成都和容兴邦广告有限公司  " + _vm._s(_vm.version) + "   \n    "), _c('a', {
    staticClass: "beian",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank",
      "title": "工信备案"
    }
  }, [_vm._v(_vm._s(_vm.show_icp) + "\n    ")]), _vm._v(" "), (_vm.showPoliceID) ? _c('a', {
    staticClass: "beian",
    staticStyle: {
      "text-decoration": "none",
      "margin-left": "6px"
    },
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010602001077",
      "target": "_blank",
      "title": "公安备案"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "position": "relative",
      "top": "1px"
    },
    attrs: {
      "src": "/static/img/police.png",
      "alt": "公安备案"
    }
  }), _vm._v("川公网安备51010602001077号\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0485a69a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Appfooter.vue
// module id = 160
// module chunks = 1